const initialState = {
    str: ''
}

const stcwExpiresRed = (state = initialState, action) => {
    switch(action.type){
        case 'STCW_EXPIRES' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default stcwExpiresRed